import { Doc, Id } from "../../_generated/dataModel";
import { FilterRule, FilterRuleCtx } from "../../lib/types/filters_types";

/**
 * Regla: filtro de permisos por rol (prioridad 3)
 * Filtra permisos asociados a un rol específico
 */
export const permissionsRoleRule: FilterRule<Doc<"permissions">> = {
  priority: 3,
  // Sin roleId devuelve [] (no "sin filtro"): no usar paginación por índice.
  appliesWithoutArgs: true,
  build: async (ctx: FilterRuleCtx, args: Partial<Omit<Doc<"permissions">, "_id" | "_creationTime">>) => {
    const { userContext } = ctx;

    // Validación: si no hay roleId, retornar array vacío
    if (!args.roleId) return [];

    // Validación: verificar que el usuario tenga companyId
    if (!userContext?.companyId) {
      throw new Error("Usuario no tiene empresa asignada");
    }

    const permissions = await ctx.db
      .query("permissions")
      .withIndex("by_company_id_role_id", (q) =>
        q
          .eq("internalControl.companyId", userContext.companyId!)
          .eq("roleId", args.roleId as Id<"roles">),
      )
      .collect();

    return permissions;
  },
};
